// import Service from '@/service/index.js';
import { mapGetters } from 'vuex';
import PurchaseBusinessService from '../../purchase-business-service.js';

export default {
  data() {
    return {
      id: '',
      detail: {},
      files: {},
      arr: ['成交人信息', '成交确认书信息'],
      activeKey: '成交确认书信息',
      houDetail: {},
      formxx: {
        approve: '',
        mark: '',
        remark: ''
      },
      form: {
        purchaseId: '',
        bidId: '',
        approveStatus: 0,
        remark: ''
      },
      rules: {
        approve: [
          { required: true, message: '请选择审核意见', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入拒绝意见', trigger: 'blur' }
        ]
      }
    };
  },
  computed: mapGetters({
    getTenantParams: 'getTenantParams'
  }),
  created() {
    this.id = this.$route.query.id;
    this.form.purchaseId = this.$route.query.id;
    PurchaseBusinessService.getPurchaseConfirmLetter(this.id).then(res => {
      if (res && res.code === '0' && res.data){
        this.detail = res && res.data.letterResForm;
        this.houDetail = res && res.data.transactorInfo;
        if(res.data.files.length > 0) {
          this.files = res && res.data.files[res.data.files.length - 1];
        }
        this.form.bidId = this.detail.bidId;
      }
    });
  },
  methods: {
    previousStep () {
      this.$router.back();
    },
    changeActiveIndex (key) {
      this.activeKey = key;
    },
    submit() {
      if(this.formxx.approve === '1'){
        this.form.approveStatus = 1;
        this.form.remark = this.formxx.mark;
      }else if(this.formxx.approve === '2'){
        this.form.approveStatus = 2;
        this.form.remark = this.formxx.remark;
      }else{
        this.form.approveStatus = 1;
        this.form.remark = this.formxx.mark;
      }
      this.$confirm('确定确认成交书？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        PurchaseBusinessService.confirmApprove(this.form).then(res => {
          console.log(res);
          if(res.code === '0'){
            this.$message({
              message: '确认成功',
              type: 'success',
              duration: 1000,
              offset: 327
            });
            this.$router.back();
          }else{
            this.$message({
              message: res.reason,
              type: 'error',
              duration: 1000,
              offset: 327
            });
          }
        });
      }).catch(() => {});
    },
    cjssubmit() {
      this.$refs['attachmentForm'].validate(valid => {
        if (valid) {
          if(this.formxx.approve === '1'){
            this.form.approveStatus = 1;
            this.form.remark = this.formxx.mark;
          }else if(this.formxx.approve === '2'){
            this.form.approveStatus = 2;
            this.form.remark = this.formxx.remark;
            if(this.form.remark === ''){
              this.$message({
                message: '请填写拒绝原因',
                type: 'error',
                duration: 1000,
                offset: 327
              });
              return false;
            }
          }else{
            this.form.approveStatus = 1;
            this.form.remark = this.formxx.mark;
          }
          this.$confirm('确定确认成交书？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            PurchaseBusinessService.confirmApprove(this.form).then(res => {
              console.log(res);
              if(res.code === '0'){
                this.$message({
                  message: '确认成功',
                  type: 'success',
                  duration: 1000,
                  offset: 327
                });
                this.$router.back();
              }else{
                this.$message({
                  message: res.reason,
                  type: 'error',
                  duration: 1000,
                  offset: 327
                });
              }
            });
          }).catch(() => {});
        } else {
          return false;
        }
      });
    }
  }
};
